module.exports = __webpack_public_path__ + "resources/img/img_kr_popup_marketing.d8149a9a3c39b111731f0c74bed0c75c.png";